interface LegendStop { value: string; label: string; color: string; }

export type LegendMetric = 'rsrp' | 'rsrq' | 'sinr' | 'download_mbps' | 'mos';

const STOPS: Record<LegendMetric, LegendStop[]> = {
  rsrp: [
    { value: '≥ -80',     label: 'Excellent', color: '#22c55e' },
    { value: '-85 dBm',   label: 'Good',      color: '#84cc16' },
    { value: '-95 dBm',   label: 'Fair',      color: '#facc15' },
    { value: '-105 dBm',  label: 'Poor',      color: '#f97316' },
    { value: '< -110',    label: 'Very poor', color: '#ef4444' },
  ],
  rsrq: [
    { value: '≥ -10',     label: 'Excellent', color: '#22c55e' },
    { value: '-13 dB',    label: 'Good',      color: '#84cc16' },
    { value: '-16 dB',    label: 'Fair',      color: '#facc15' },
    { value: '-18 dB',    label: 'Poor',      color: '#f97316' },
    { value: '< -20',     label: 'Very poor', color: '#ef4444' },
  ],
  sinr: [
    { value: '≥ 20 dB',   label: 'Excellent', color: '#22c55e' },
    { value: '13 dB',     label: 'Good',      color: '#84cc16' },
    { value: '7 dB',      label: 'Fair',      color: '#facc15' },
    { value: '0 dB',      label: 'Poor',      color: '#f97316' },
    { value: '< 0',       label: 'Very poor', color: '#ef4444' },
  ],
  download_mbps: [
    { value: '≥ 200 Mbps', label: '5G+',     color: '#22c55e' },
    { value: '100 Mbps',   label: '5G/4G+',  color: '#84cc16' },
    { value: '50 Mbps',    label: '4G',      color: '#facc15' },
    { value: '10 Mbps',    label: '3G',      color: '#f97316' },
    { value: '< 10',       label: 'Edge',    color: '#ef4444' },
  ],
  mos: [
    { value: '≥ 4.0',   label: 'Excellent', color: '#22c55e' },
    { value: '3.6',     label: 'Good',      color: '#84cc16' },
    { value: '3.1',     label: 'Fair',      color: '#facc15' },
    { value: '2.6',     label: 'Poor',      color: '#f97316' },
    { value: '< 2.6',   label: 'Bad',       color: '#ef4444' },
  ],
};

const METRIC_TITLES: Record<LegendMetric, string> = {
  rsrp: 'RSRP (signal)',
  rsrq: 'RSRQ (quality)',
  sinr: 'SINR (S/N)',
  download_mbps: 'Download',
  mos: 'MOS (voice)',
};

export interface MapLegendProps {
  metric: LegendMetric;
  cellCount?: number;
}

export default function MapLegend({ metric, cellCount }: MapLegendProps) {
  const stops = STOPS[metric];
  return (
    <div
      style={{
        position: 'absolute', right: 12, bottom: 12, zIndex: 6,
        background: 'rgba(11, 18, 32, 0.92)',
        border: '1px solid #1f2937',
        borderRadius: 10,
        padding: '10px 12px',
        color: '#e5e7eb',
        fontSize: 11,
        minWidth: 170,
        boxShadow: '0 4px 12px rgba(0,0,0,.4)',
      }}
    >
      <div style={{ fontWeight: 700, marginBottom: 6, letterSpacing: 0.5, color: '#f9fafb' }}>
        {METRIC_TITLES[metric]}
      </div>
      {stops.map((s) => (
        <div key={s.value} style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 3 }}>
          <span style={{ width: 14, height: 14, borderRadius: 3, background: s.color, display: 'inline-block', flex: '0 0 auto' }} />
          <span style={{ fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace', minWidth: 70 }}>{s.value}</span>
          <span style={{ color: '#9ca3af' }}>{s.label}</span>
        </div>
      ))}
      {cellCount != null && (
        <div style={{ marginTop: 6, paddingTop: 6, borderTop: '1px solid #1f2937', color: '#9ca3af' }}>
          {cellCount.toLocaleString()} cells
        </div>
      )}
    </div>
  );
}
